import * as React from "react";
function SvgXfFilter(props) {
    return (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M3 6.875a1.125 1.125 0 000 2.25h26a1.125 1.125 0 000-2.25H3zM7 14.875a1.125 1.125 0 000 2.25h18a1.125 1.125 0 000-2.25H7zM12 22.875a1.125 1.125 0 000 2.25h8a1.125 1.125 0 000-2.25h-8z" })));
}
export default SvgXfFilter;
